import Typography from "@mui/material/Typography";
import {ReactNode} from "react";

export interface SectionHeaderProps {
    children: ReactNode;
}

export default function SectionHeader({children}: Readonly<SectionHeaderProps>) {
    return (
        <Typography variant={"body2"} fontWeight={"bold"} color={"primary"}>{children}</Typography>
    );
}